import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from '../component/layouts/dashboard/dashboard.component';
import { AuthGuard } from '../shared/auth.guard';
import { PermissionGuard } from '../shared/permission.guard';
import { CartaPorteCreateComponent } from 'src/app/carta-porte/carta-porte-create/carta-porte-create.component';
import { CartaPorteListComponent } from 'src/app/carta-porte/carta-porte-list/carta-porte-list.component';
import { CartaPorteAddComponent } from 'src/app/carta-porte/carta-porte-add/carta-porte-add.component';
import { CartaPorteEditComponent } from 'src/app/carta-porte/carta-porte-edit/carta-porte-edit.component';
import { CartaPorteViewComponent } from 'src/app/carta-porte/carta-porte-view/carta-porte-view.component';

const routes: Routes = [{
  path: 'carta-porte',
  component: DashboardComponent,
  canActivate: [AuthGuard, PermissionGuard],
  children: [{
    path: 'list',
    component: CartaPorteListComponent,
    data: { module: 'Carta Porte', accion: 'Listado de Carta Porte', type: 'list' }
  }, {
    path: 'create',
    component: CartaPorteCreateComponent,
    data: { module: 'Carta Porte', accion: 'Creación de Carta Porte', type: 'add' }
  }, {
    path: 'add',
    component: CartaPorteAddComponent,
    data: { module: 'Carta Porte', accion: 'Creación de Carta Porte', type: 'add' }
  }, {
    path: 'add/:serviceId',
    component: CartaPorteAddComponent,
    data: { module: 'Carta Porte', accion: 'Creación de Carta Porte', type: 'add' }
  }, {
    path: 'view/:id',
    component: CartaPorteViewComponent,
    data: { module: 'Carta Porte', accion: 'Detalle de Carta Porte', type: 'view' }
  }, {
    path: 'update/:id',
    component: CartaPorteEditComponent,
    data: { module: 'Carta Porte', accion: 'Actualización de Carta Porte', type: 'update' }
  }]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CartaPorteRoutingModule { }
